import template from './wizard_holiday_setup.html';

class WizardHolidaySetup
{
	constructor (dialog)
	{
		this.dialog = dialog;
		let today = new Date();
		let oneyear = new Date().setFullYear(new Date().getFullYear() + 1);
		this.from_date = ko.observable(new Date(today).toJSON().slice(0, 10));
		this.to_date = ko.observable(new Date(oneyear).toJSON().slice(0, 10));
		this.selected_holiday_type = ko.observable() ;
		this.holidays = ko.observableArray();

		this.from_date.subscribe((newText) => {
			this.load_holidays();
		});

		this.to_date.subscribe((newText) => {
			this.load_holidays();
		});
	};

	close()
	{
		this.dialog.close();
	}

	async load_holidays()
	{
		if (this.selected_holiday_type() != null)
		{
			let res = await Grape.fetches.getJSON('/holiday/list_holidays', {
				holiday_type: this.selected_holiday_type(),
				from_date: this.from_date(),
				to_date: this.to_date()
			});
		for (let i = 0; i < res.holidays.length; i++) {
			res.holidays[i].edit_mode = false;
		}
			this.holidays(res.holidays || []);
		}
	}

	async save_holiday(v, e)
	{
		let data = ko.toJS(v);
		data.command = 'modify';
		let res = await Grape.fetches.postJSON('/admin/is_holiday_safe_to_modify', data);
		if (res.status == 'OK')
		{
			if (res.is_safe == false)
			{
				let my_message = '';
				if (res.old_count != null)
					my_message += 'There are ' + res.old_count + ' leave entries that overlaps with the previous date(' + res.old_date + ').\n';

				if (res.new_count != null)
					my_message += 'There are ' + res.new_count + ' leave entries that overlaps with the new date(' + res.new_date + ').\n';

				my_message += tr('Unfortunately the holiday can not be added because of the overlapping leave');

				Grape.alerts.alert({ type: 'error' , message : my_message, title: tr('Error')});
			}

			if (res.is_safe == true)
				this.callSaveHolidayPost(data);
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};

	async delete_holiday (v, e)
	{
		let data = ko.toJS(v);
		data.command = 'delete';

		// first check if this holiday is safe to modify
		let res = await Grape.fetches.postJSON('/admin/is_holiday_safe_to_modify', data)
		if (res.status == 'OK')
		{
			if (res.is_safe == false)
			{
				let response = await Grape.alerts.confirm({
					type: 'warning',
					title: 'Deleting Holiday Date',
					message: 'There are ' + res.old_count + ' leave entries that overlaps with this date(' + res.old_date + '). Proceeding will cause these leave entries to be reprocessed.',
					accept_text: 'Proceed',
					cancel_text: 'Cancel'
				});

				if (response)
					this.callDeletePost(data);
			}

			if (res.is_safe == true)
				this.callDeletePost(data);
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};

	async callDeletePost(data)
	{
		let url = '/admin/delete_holiday';

		let res = await Grape.fetches.postJSON(url, data);
		if (res.status == 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Successfully deleted holiday.', 'Successfully deleted holiday.'), title: tr('Success', 'Success')});
			this.load_holidays();
			//location.reload();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};

	async callSaveHolidayPost(data)
	{
		let url = '/admin/save_holiday';

		let res = await Grape.fetches.postJSON(url, data);
		if (res.status == 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Successfully saved holiday.', 'Successfully saved holiday.'), title: tr('Success', 'Success')});
			this.load_holidays();
			//location.reload();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};

	add_holiday()
	{
		if (this.holidays() != null)
		{
			this.holidays.unshift({
				edit_mode: true,
				id: null,
				description: '',
				holiday_date: null,
				holiday_type: this.selected_holiday_type()
			});
		}
		else
		{
			this.holidays({
				edit_mode: true,
				id: null,
				description: '',
				holiday_date: null,
				holiday_type: this.selected_holiday_type()
			});
		}
	}

	edit_holiday(v,e)
	{
		let data = ko.toJS(v);
		//let holidays = this.holidays();
		let new_holidays = this.holidays().map(obj => {
			if (obj.id === data.id)
				return {...obj, edit_mode: true};

			return obj;
		});

		this.holidays(new_holidays);
	}

	async import_holidays()
	{
		await Grape.dialog.open('AdminImportHoliday', { holiday_type: this.selected_holiday_type()});
		this.load_holidays();
	}
};

class WizardHolidaySetupPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardHolidaySetup(this);
	};

	init()
	{
		this.viewModel.selected_holiday_type(this.bindings.holiday_type);
	}
};

export default {
	name: 'WizardHolidaySetup',
	dialog_class: WizardHolidaySetupPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_holiday_setup',
	provider: 'ps'
};
